var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAvailabilityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E7F3DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5H15.5V13H14.5V14.5H13V15.5H14.5V17H15.5V15.5H17V14.5Z",
    fill: "#48A14D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C12.8 19 11 17.2 11 15C11 12.8 12.8 11 15 11C17.2 11 19 12.8 19 15C19 17.2 17.2 19 15 19ZM15 12C13.35 12 12 13.35 12 15C12 16.65 13.35 18 15 18C16.65 18 18 16.65 18 15C18 13.35 16.65 12 15 12Z",
    fill: "#48A14D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7C18 6.45 17.55 6 17 6H15V5H14V6H10V5H9V6H7C6.45 6 6 6.45 6 7V17C6 17.55 6.45 18 7 18H10V17H7V7H9V8H10V7H14V8H15V7H17V10H18V7Z",
    fill: "#48A14D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAvailabilityIcon);
export default __webpack_public_path__ + "static/media/addAvailabilityIcon.f2ec19a599081cfda2ca650247368101.svg";
export { ForwardRef as ReactComponent };